module.exports = __webpack_public_path__ + "img/google-analytics.cd05b510.svg";